<template>
  <!-- <div class="index">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar> -->
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">
                  <span data-tour-step="1"
                    >Halo {{ memberSessionArr.name }}!</span
                  >
                </h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Overview</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
              <ul class="nav float-right custom-menu">
                <li class="dropdown dropdown-action">
                  <a
                    href
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="material-icons">more_vert</i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <!-- <a @click.prevent="tourShow" class="dropdown-item" href="javascript:void(0)">Tour Guide</a> -->
                    <a
                      target="_blank"
                      class="dropdown-item"
                      href="https://docs.waajo.id/automation-chat-ai/perbedaan-fitur-chat-ai-dan-chatbot"
                      >Dokumentasi</a
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- /Page Header -->
          <!-- <div class="row">
            <div class=" col-md-12 col-sm-12 col-lg-12 col-xl-12">
              <div class=" ">
                <div class=" ">
                  <div class="alert alert-info row">
                    <div class="col-md-3 text-center">
                      <img class="img-fluid" style="  height:auto" src="@/assets/chat.png" />
                    </div>
                    <div class="col-md-9 text-wrap">
                      <h5>🧠🚀 Tingkatkan Layanan Bisnis Kamu Dengan WAAJO Chat AI – Solusi Cerdas Untuk Bantu Obrolan
                        Dengan Pelanggan!</h5>
                      <p>
                      <ul style="list-style:none;">
                        <li><i class="fa fa-check text-success"></i> Bisnis tetap jalan, meski di luar jam kerja. </li>
                        <li><i class="fa fa-check text-success"></i> Weekend tetap tenang. Asisten AI aktif terus buat
                          bantu respon pesan customer kapan saja.
                        </li>
                        <li><i class="fa fa-check text-success"></i> Customer tanya malam-malam? Sekarang AI yang bantu
                          jawab duluan. Kamu tinggal follow-up pas
                          jam kerja!</li>
                      </ul>
                      </p>
                      <div class="text-left" style="margin-top:10px;">
                        <router-link :to="'/ai/pricing'" v-if="aiDetail.ai_engine == ''"
                          class="btn btn-primary btn-sm btn-outline-lime"><i class="la la-coffee"></i> Coba
                          Gratis</router-link>
                        <router-link :to="'/aikey'" class="btn btn-info btn-sm btn-outline-lime" v-else><i
                            class="la la-coffee"></i> AI
                          Aktif! Cek sesi AI disini ...</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <information
            :is-active="aiBalance.is_available"
            :mode="chatAiMode" 
            @activate="$router.push('/ai/pricing')"
            @manage="$router.push('/aikey')" 
          /> -->
          <div class="row">
            <div class="col-md-12 mb-4" v-if="aiBalance.is_available">
              <status
                :balance="rowTotalTokenAI.total_tokens"
                :used="rowTotalTokenAI.total_tokens_used"
                :is-active="aiBalance.is_available"
                @manage-knowledge="$router.push('/ai/historykb')"
              />
            </div>
            <div class="col-md-12 mb-4">
              <Information @activate="$router.push('/ai/pricing')"  :showRegister="aiBalance.is_available == false" />
            </div>

            
            <!-- <pre>{{ aiDetail }}</pre> -->
          </div>
          <!-- <div class="row" v-if="aiBalance.is_available == true">
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <div class="card dash-widget" data-tour-step="2">
                <div class="card-body">
                  <span class="dash-widget-icon">
                    <i class="fa fa-magic"></i>
                  </span>
                  <div class="dash-widget-info">
                    <h3>
                      {{ nFormatter(rowTotalTokenAI.total_tokens) }}
                    </h3>
                    <span>
                      <router-link :to="'/ai/pricing'"
                        >Saldo Token AI</router-link
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <div class="card dash-widget">
                <div class="card-body">
                  <span class="dash-widget-icon">
                    <i class="fa fa-signal"></i>
                  </span>
                  <div class="dash-widget-info">
                    <h3>AI Status</h3>
                    <span
                      class="text text-success"
                      v-if="aiBalance.is_available == true"
                    >
                      <i class="fa fa-check"></i> Available
                      <small
                        v-if="aiDetail.trial_status == 1"
                        class="text-muted"
                        >free</small
                      >
                    </span>
                    <span class="text text-danger" v-else>
                      <i class="fa fa-remove"></i> Not Available
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <div class="card dash-widget">
                <div class="card-body">
                  <span class="dash-widget-icon">
                    <i class="fa fa-file"></i>
                  </span>
                  <div class="dash-widget-info">
                    <h3 class="text text-danger">
                      {{ nFormatter(rowTotalTokenAI.total_tokens_used) }}
                    </h3>
                    <span> Token Digunakan </span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <!-- Statistics Widget -->
          <!-- <broadcast /> -->

          <!-- /Statistics Widget -->
        </div>
        <!-- /Page Content -->
    <v-tour
      name="tourGuide"
      :steps="tourSteps"
      :callbacks="tourCallbacks"
    ></v-tour>
      </div>
    <!-- </div> -->
    <!-- /Page Wrapper -->
  <!-- </div> -->
</template>
<script>
import Lottie from "vue-lottie";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/SidebarChatbot.vue";
import { nFormatter, getCurrentMonth } from "@/utils/helper";
import Vue from "vue";
import { mapGetters } from "vuex";
import Information from "./Information.vue";
import Status from "./Status.vue";
export default {
  components: {
    LayoutHeader,
    Information,
    LayoutSidebar,
    Status,
  },
  data() {
    return {
      rowTotalTokenAI: {
        total_tokens: "0",
        total_tokens_used: "0",
      },
      aiDetail: {
        ai_engine: "",
        trial_status: 1,
        trial_expire: 0,
      },
      // aiBalance: {
      //   is_available: false,
      //   balance_infos: [
      //     {
      //       currency: "USD",
      //       total_balance: "0",
      //       granted_balance: "0.00",
      //       topped_up_balance: "0.00",
      //     },
      //   ],
      // },
      contactWaajo: process.env.VUE_APP_CONTACT_WAAJO,
      // animationsForm1: { animationData: animationReview, loop: true },
      tourId: "dashboard.admin",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete,
      },
      tourSteps: [
        {
          target: '[data-tour-step="1"]', // We're using document.querySelector() under the hood
          content: `Kamu bisa melihat statistik dan notifikasi lisensi di halaman Beranda.`,
        },
        {
          target: '[data-tour-step="2"]',
          content:
            "Informasi jumlah <b>Voucher Aktif</b> yang dapat digunakan untuk membuat akun Whatsapp baru atau memperpanjang masa aktif akun lama.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="3"]',
          content: "Jumlah akun Whatsapp yang dibuat.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="4"]',
          content: "Jumlah Kontak.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="5"]',
          content:
            "Total pesan terkirim dari semua lisensi sejak awal digunakan.",
          params: {
            placement: "top",
          },
        },
        {
          target: '[data-tour-step="6"]',
          content: "Statistik pesan dalam waktu 6 bulan terakhir.",
          params: {
            placement: "top",
          },
        },
      ],
    };
  },
  computed: {
    showModalOnlineDemo() {
      return this.$store.state.login.showModalOnlineDemo;
    },
    ...mapGetters(["fieldsGetLicenseList"]),
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    },
    numLicenseTotal() {
      return this.$store.state.member.numLicenseTotal;
    },
    numAgentTotal() {
      return this.$store.state.member.numAgentTotal;
    },
    numMessageTotal() {
      return this.$store.state.member.numMessageTotal;
    },
    numActiveVoucherTotal() {
      return this.$store.state.member.numActiveVoucherTotal;
    },
    numContactsTotal() {
      return this.$store.state.member.numContactsTotal;
    },
    aiBalance() {
      return this.$store.state.aiKey.aiBalance;
    },
  },
  created() {
    this.$store.dispatch("member/getActiveVoucherTotal");
    // this.tourDetail();
    this.getAIDetail();
    this.getBalance();
    this.getTotalTokenAI();
  },
  mounted() {
    // let calendlyScript = document.createElement("script");
    // calendlyScript.setAttribute(
    //   "src",
    //   "https://assets.calendly.com/assets/external/widget.js"
    // );
    // document.head.appendChild(calendlyScript);
  },
  methods: {
    async getTotalTokenAI() {
      this.$store
        .dispatch("dashboard/TotalTokenAI") // sesuai kan dengan method di API
        .then((response) => {
          var { data } = response;
          this.rowTotalTokenAI = data;
        });
    },
    getAIDetail() {
      // this.licenseArrLoading = true;
      this.$store
        .dispatch("aiKey/getDetail") // sesuai kan dengan method di API
        .then((response) => {
          let { data } = response;
          this.aiDetail = data;
          // console.log("ai detail", data)
        });
    },

    getCurrentMonth() {
      return getCurrentMonth();
    },
    closeModalOnlineDemo() {
      this.$store.dispatch("login/actHideModalOnlineDemo");
    },
    redirectToLicenseByClick() {
      this.fieldsGetLicenseList.license_status = "";
      this.$router.push({ path: "/license/list" });
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    getMessageTotal() {
      let params = {};
      params = {
        provider: "whatsapp",
      };
      this.$store.dispatch("member/getMessageTotal", params);
    },
    getLicenseTotal() {
      this.$store.dispatch("member/getLicenseTotal");
    },
    getAgentTotal() {
      this.$store.dispatch("member/getAgentTotal");
    },
    getContactsTotal() {
      this.$store.dispatch("member/getContactsTotal");
    },
    getBalance() {
      // console.log("geetttt")
      this.isLoading = true;
      this.$store
        .dispatch("aiKey/getBalance")
        .then((response) => {
          this.isLoading = false;
          // let { data } = response;
          // // this.aiBalance = data;
        })
        .catch((err) => {
          // console.log("errr",err)
          this.isLoading = false;
        });
    },
  },
  name: "index",
};
</script>



// WEBPACK FOOTER //
// src/views/ai/chat/overview/index.vue